export const getIsNullish = (value: any): value is undefined | null =>
  value === undefined || value === null;
